import { render, staticRenderFns } from "./MaterialBlock.vue?vue&type=template&id=da5bd172&"
import script from "./MaterialBlock.vue?vue&type=script&lang=js&"
export * from "./MaterialBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports